import { render, staticRenderFns } from "./ImportacionForm.vue?vue&type=template&id=fefef3b6&scoped=true"
import script from "./ImportacionForm.vue?vue&type=script&lang=ts"
export * from "./ImportacionForm.vue?vue&type=script&lang=ts"
import style0 from "./ImportacionForm.vue?vue&type=style&index=0&id=fefef3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefef3b6",
  null
  
)

export default component.exports